// @flow
export const styles = (theme: Object): Object => ({
    root: {
        overflow: 'hidden',
        backgroundColor: '#f8f8f8',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 20,
    },
    desktopRoot: {
        // height: 'calc(100vh - 230px)',
        minHeight: theme.constants.MIN_HEIGHT_LIMITED_LAYOUT,
    },
    mobileRoot: {
        // height: 'calc(100vh - 230px)',
        minHeight: 450,
    },
    loader: {
        padding: 20,
        marginTop: 10,
    },
    widthLimiter: {
        maxWidth: theme.constants.MAX_WIDTH_LIMITED_LAYOUT,
    },
    headerContainer: {
        paddingLeft: 17,
    },
    userReviewList: {
        width: theme.constants.MAX_WIDTH_LIMITED_LAYOUT,
        padding: 0,
    },
    userCommentContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
});

export default styles;
